import {
  ApplicationConfig,
  LOCALE_ID,
  provideAppInitializer,
  inject,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { provideRouter } from '@angular/router';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { authInterceptor, errorInterceptor } from '@absti/ng-lib';
import { mockLibApiInterceptor } from '@absti/ng-lib/testing';
import { routes } from './app.routes';
import { AppService } from './services/app.service';
import { AppStateService } from './services/app-state.service';
import { environment } from '../environments/environment';
import { mockAppApiInterceptor } from './mock-api.interceptor';
import { shellRefreshInterceptor } from './proto/session/shell-refresh.interceptor';

registerLocaleData(localeEsAr);

// App mock first: its tenants/current handler must run before the library mock, which would
// otherwise answer it as GET /tenants/:oid.
const interceptors: HttpInterceptorFn[] = [
  shellRefreshInterceptor,
  ...(environment.mock ? [mockAppApiInterceptor, mockLibApiInterceptor] : []),
  authInterceptor,
  errorInterceptor,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors(interceptors)),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    { provide: LOCALE_ID, useValue: 'es-AR' },

    provideAppInitializer(() => {
      const appService = inject(AppService);
      const appState = inject(AppStateService);

      return appService
        .getConfig()
        .toPromise()
        .then(config => {
          if (config) {
            appState.version.set(config.version ?? '');
            appState.captcha.set(config.captcha ?? false);
            appState.captchaKey.set(config.captchaKey ?? null);
          }
          return appService.autoLogin().toPromise();
        })
        .catch(() => {
          // Silent — app can still show login page
        });
    }),
  ],
};
